import { Fragment } from 'react';
import { useTheme } from 'styled-components';

import { Environment } from '../../../constants/environments';
import { CountryImages, ImagesApp } from '../../../constants/images';
import { useBreadCrumbsContext } from '../../../hooks/contexts/breadCrumb.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import PillButtonColorTheme from '../../Buttons/PillButtonColorTheme';
import { SupportIcon } from '../../SvgCustom';
import Step from '../Step';
import * as Style from './appbar.styles';
import DropDownMenu from './DropDownMenu';
import { LocaleSelect, SelectedLocale } from './LocaleSelect';
import { StyledBadgeLocale } from './LocaleSelect/styles.localeSelect';

const AppBar = () => {
  const { breadCrumbs, isConfirmationPage, isResalePage } = useBreadCrumbsContext();
  const { currentLocale, translate } = useI18nContext();
  const theme = useTheme();

  // `currentLocale.locale` is already the canonical BCP-47 tag, which is what
  // the flag map is keyed by — no re-spelling needed.
  const locale = currentLocale.locale;
  const shouldHideBreadcrumbs = isConfirmationPage || isResalePage;

  return (
    <Style.Container $hideContent={shouldHideBreadcrumbs} id="appbar-container">
      <Style.BreadCrumbs id="breadcrumbs-container">
        <Fragment>
          {breadCrumbs.map((breadCrumb, index) => (
            <Step
              key={index}
              step={index}
              {...breadCrumb}
              idRef={`breadcrumb-${index}`}
            />
          ))}
        </Fragment>
      </Style.BreadCrumbs>

      <Style.ContainerOptions id="container-options">
        <PillButtonColorTheme
          onClick={() => window.open(Environment.SUPPORT_LINK, '_blank')}
          id="support-button"
          data-testid="support-button"
        >
          <img src={SupportIcon({ colorTheme : theme.colors.accent.primary })} alt="support" id="support-button-icon" />
          {translate(['BUTTONS', 'SUPPORT'])}
        </PillButtonColorTheme>
        <Style.LocaleSelector id="locale-selector-container">
          <StyledBadgeLocale
            src={ImagesApp.countries[locale as keyof CountryImages]} alt="locale flag" id="locale-flag" />
          <DropDownMenu
            prefixDropDown={<SelectedLocale />}
            contentDropDown={<LocaleSelect />}
          />
        </Style.LocaleSelector>
      </Style.ContainerOptions>
    </Style.Container>
  );
};

export default AppBar;
